// extracted by mini-css-extract-plugin
module.exports = {"tempsLectura":"tempsLectura_tempsLectura__HuYke","inline":"tempsLectura_inline__Tv18A"};